module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[59]424.678434f.woff2";